// extracted by mini-css-extract-plugin
export default {"emailLink":"Remunerations_emailLink__jlhgY","remuContainer":"Remunerations_remuContainer__rXlha"};